<template>
  <div>
    <div class="wrap">
      <div class="container lnb">
        <div class="contents_wrap">
          <div class="contents">
            <div class="title">
              {{ title }}
              <el-button class="title_btn" type="primary" @click="$router.push('profile/detail')">등록</el-button>
              <div class="clear"></div>
            </div>
            <div class="table_wrap">
              <div class="c_table_wrap table_search_wrap">
                <table>
                  <colgroup>
                    <col width="200px;">
                    <col width="">
                  </colgroup>
                  <tbody>
                  <tr>
                    <td class="c_t_title">이름 검색</td>
                    <td>
                      <div class="search">
                        <el-input class="table_s_input"
                                  v-model="tableSearch"
                                  size=""
                                  prefix-icon="el-icon-search"
                                  placeholder="검색어를 입력해주세요."
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="c_t_title">문의 작성일</td>
                    <td>
                      <div class="date">
                        <el-button @click="changeFilterDate('today')" type="info">오늘</el-button>
                        <el-button @click="changeFilterDate('week')" type="info">7일</el-button>
                        <el-button @click="changeFilterDate('month')" type="info">한달</el-button>
                        <el-button @click="changeFilterDate('year')" type="info">1년</el-button>
                        <el-button @click="changeFilterDate('')" type="info">전체</el-button>
                        <el-date-picker
                                v-model="filterDate"
                                type="daterange"
                                range-separator="~"
                                value-format="yyyy-MM-dd"
                                start-placeholder="시작날짜"
                                end-placeholder="끝 날짜"
                        >
                        </el-date-picker>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="c_t_title">노출 상태</td>
                    <td>
                      <div>
                        <el-radio-group v-model="filterStatus">
                          <el-radio :label="''">전체</el-radio>
                          <el-radio :label="1">노출</el-radio>
                          <el-radio :label="false">노출중지</el-radio>
                        </el-radio-group>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="table_search search_btn_wrap text_center">
                <el-button type="primary" class="search_btn" @click="getList">검색</el-button>
              </div>
              <div class="table_search row has_bc">
                <el-row>
                  <el-col :span="12">
                    <el-button type="danger" size="small" class="p_del_btn" @click="tableDel()">선택항목삭제</el-button>
                  </el-col>
                  <el-col class="text_right"  :span="12">
                    <el-select
                            v-model="pageRow"
                    >
                      <el-option
                              v-for="row in pageRows"
                              :key="row"
                              :label="`${row}개 씩보기`"
                              :value="row"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
              <el-table
                      :data="ApiData"
                      style="width: 100%"
                      empty-text="데이터가 없습니다."
                      @cell-click="cellClick"
                      @selection-change="tableSelectChnage"
                      v-loading="tableLoading"
              >
                <el-table-column
                        type="selection"
                        width="55"
                        class-name="text-center"
                >
                </el-table-column>
                <el-table-column
                        class="table_no"
                        type="index"
                        label="#"
                        width="70"
                        class-name="num"
                        :index="tableIndex"
                >
                </el-table-column>

                <el-table-column
                        v-for="(header, index) in tableHeader"
                        :key="index"
                        :label = header.label
                        :width = header.width
                        :sortable="header.sortable"
                        :class-name="`${header.class}`"
                        :cell="header.prop"
                        :prop="header.sortProp"
                >
                  <template slot-scope="scope">
                    <div
                            :class="{'has_cursor': header.hasClickable}"
                    >
                      <div class="table_img" v-if="header.prop === 'img'">
                        <div class="table_img" v-if="scope.row.hasOwnProperty('File')"
                             :style="`background-image: url(${scope.row.File[0].thumb_url})`"></div>
                      </div>
                      <div class="table_file_wrap"
                           v-else-if="header.prop === 'file'"
                      >
                        <div class="table_file" v-if="scope.row.File">
                          <a
                                  v-for="(file, index) in scope.row.File"
                                  :key="index"
                                  :href="file.thumb_url"
                                  target="blank"
                          >
                            {{file.org_name}} <i class="el-icon-download"></i>
                          </a>
                        </div>
                      </div>
                      <span
                              v-else
                              v-html="$_.result(scope.row, header.prop) ? $_.result(scope.row, header.prop) : isNaN($_.result(scope.row, header.prop)) || $_.result(scope.row, header.prop) === null || $_.result(scope.row, header.prop) === '' ? '-' : $_.result(scope.row, header.prop)"
                      >
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="tableoption"
                                 align="center"
                                 width="200"
                                 label="옵션"
                                 class-name="table_bottons"
                >
                  <template slot-scope="scope">
                    <el-button
                            size="mini"
                            type="warning"
                            @click="goDetail(scope.$index, scope.row)">수정하기</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagnation_wrap">
                <el-pagination
                        v-show="apiPage.total > 0"
                        :page-size = pageRow
                        :pager-count = 11
                        layout="prev, pager, next"
                        :current-page.sync = page
                        :page-sizes="[10, 20, 30]"
                        :total="apiPage.total"
                        @current-change="getList"
                >
                </el-pagination>
              </div>
              <div class="table_search row has_bc">
                <el-row>
                  <el-col :span="12">
                    <el-button type="danger" size="small" class="p_del_btn" @click="tableDel()">선택항목삭제</el-button>
                  </el-col>
                  <el-col :span="12" class="text_right">
                    <el-select
                            v-model="pageRow"
                    >
                      <el-option
                              v-for="row in pageRows"
                              :key="row"
                              :label="`${row}개 씩보기`"
                              :value="row"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <page-footer></page-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import VuxAlert from '@/mixins/vux-alert';
    import util from '@/mixins/util';
    import List from '@/mixins/List';
    import localStorage from '@/mixins/localStorage'
    import {mapGetters, mapState} from "vuex";

    let params = {};
    export default {
        name: 'ProfileBorder',
        mixins: [ VuxAlert , List, localStorage ],
        components: {
        },
        data() {
            return{
                title: this.$route.meta.title,
                tableSearch: '',
                searchOption: 'ti',
                filterDate: '',
                filterStatus: '',
                tableHeader: [
                    {
                        label: 'IMG',
                        prop: 'img',
                        sortable: false,
                        class: 'text_center',
                        width: 200,
                    },
                    {
                        label: '이름',
                        prop: 'p_title',
                        sortable: false,
                        class: 'text_center',
                    },
                    {
                        label: '노출상태',
                        prop: 'statusName',
                        sortable: false,
                        class: 'text_center',
                    },
                    {
                        label: '등록일',
                        prop: 'created_at',
                        sortable: false,
                        class: 'text_center',
                    },
                ],
                tableoption: true,
                pageRows: [10, 30, 50],
            }
        },

        mounted() {
            this.getList();
        },
        beforeRouteLeave(to, from, next){
            if(to.path === "/auth" && this.$localStorage.get('token')){
                next(false);
            }else{
                return next();
            }
        },
        computed: {
            ...mapState({
                UserInfo: state => state.common.UserInfo,
            }),
        },
        methods: {
            initData(){
                this.tableData = [];
                this.page = 1;
                this.tableLoading = true;
                this.selectRow = [];
            },
            getList() {
                this.tableLoading = true;
                params = {
                    ip: 1,
                    sp: this.pageRow,
                    page : this.page,
                    pt : 'member'
                }
                if(!util.isEmpty(this.filterDate) && this.filterDate.length > 0) {
                    params.crsd = this.filterDate[0];
                    params.cred = this.filterDate[1];
                }
                if(this.tableSearch != '') {
                    params[this.searchOption]= this.tableSearch;
                }
                if(this.filterStatus !== ''){
                    params.isdi = this.filterStatus === 1 ? 1  : 0;
                }
                let obj = {key : 'p_is_display', oneName : '노출' , zeroName :'노출중지'};
                this.getStatusApiResult(this.$api.$member.getProfile(params),obj);
            },
            changeFilterDate(date) {
                if(date === 'today')  {
                    this.filterDate = [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')];
                }else if(date === 'week') {
                    this.filterDate = [this.$moment().add(-1, 'w').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
                }else if(date === 'month') {
                    this.filterDate = [this.$moment().add(-1, 'M').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
                }else if(date === 'year') {
                    this.filterDate = [this.$moment().add(-1, 'y').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
                }else if(date === '') {
                    this.filterDate = null;
                }
            },
            goDetail(index, row) {
                this.MoveChild("profile/detail/" + row.p_idx)
            },
            tableSelectChnage(row) {
                this.selectRow = row;
            },
            tableDel() {
                if(this.selectRow.length === 0){
                    this.createAlert({
                        title: '',
                        content: '체크박스를 선택해주세요',
                        btnText: '확인',
                    });
                }else{
                    let alertParams = {'element' : this, 'key': this.selectRow, id: this.UserInfo.mb_id };
                    this.listDeleteInputConfirm(alertParams);
                }
            },

            async dataDelete(obj,password) {
                this.choiceRow = obj;
                let alertTxt = {
                    title: '',
                    content: '삭제 성공'
                };
                await this.choiceRow.forEach(row => {
                    params = {
                        p_type: 'member',
                        p_idx: row.p_idx,
                        mb_password: password
                    }
                    this.$api.$member.deleteProfile(params).then(res => res.Data.Result).then(res => {
                        if(!res.Info.status) {
                            alertTxt.title = ''
                            alertTxt.content = '삭제 실패'
                            return false;
                        }
                    });
                });
                await this.createAlert({
                    title: alertTxt.title,
                    content: alertTxt.content,
                    btnText: "확인",
                    hide :() => {
                        this.getList();
                    }
                });
            },
        }
    }
</script>
